import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { AppProps } from "common/lib/getAppServerSideProps";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
import { pageUrl } from "common/lib/router";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
export const DesktopMenu = () => {
  "use memo";

  const $ = _c(19);
  const {
    navItems,
    pageSlug,
    regionCode
  } = usePageProps();
  const t = useTranslations("layout.header");
  const {
    section_nav: t0
  } = useRegionConfig();
  const {
    custom_nav_link: customNavLink
  } = t0;
  let t1;
  if ($[0] !== pageSlug || $[1] !== regionCode) {
    t1 = pageUrl.view({
      regionCode,
      pageSlug
    });
    $[0] = pageSlug;
    $[1] = regionCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentPathname = t1;
  const isCustomNavLinkActive = currentPathname === customNavLink.link;
  let t2;
  if ($[3] !== t) {
    t2 = t("sections_nav_label");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentPathname || $[6] !== navItems) {
    let t4;
    if ($[8] !== currentPathname) {
      t4 = t5 => {
        const {
          title,
          path
        } = t5;
        const isCurrentPage = currentPathname === path;
        return <a key={path} href={path} className={clsx("mr-2.5 border-b-4 pt-3 pb-2 font-sans hover:border-red-600 2xl:mr-4", {
          "border-red-600": isCurrentPage,
          "border-transparent": !isCurrentPage
        })}>{title}</a>;
      };
      $[8] = currentPathname;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = [...navItems].sort(_temp).map(t4);
    $[5] = currentPathname;
    $[6] = navItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== customNavLink.enabled || $[11] !== customNavLink.link || $[12] !== customNavLink.title || $[13] !== isCustomNavLinkActive) {
    t4 = customNavLink.enabled ? <a className={clsx("ml-auto border-b-4 pt-3 pb-2 hover:border-red-600", {
      "border-red-600": isCustomNavLinkActive,
      "border-transparent": !isCustomNavLinkActive
    })} href={customNavLink.link}>{customNavLink.title}</a> : null;
    $[10] = customNavLink.enabled;
    $[11] = customNavLink.link;
    $[12] = customNavLink.title;
    $[13] = isCustomNavLinkActive;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <nav className="text-3xs lg:text-2xs hidden font-bold text-black lg:flex 2xl:text-sm" data-testid="desktopMenu" aria-label={t2}>{t3}{t4}</nav>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp(navItemA, navItemB) {
  return navItemA.position - navItemB.position;
}